import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { createFocusTrap } from 'focus-trap'

export default (images) => ({
    images: images || [],
    visibleImagesCount: 4,
    activeIndex: null,

    get visibleImages() {
        return this.images.slice(0, this.visibleImagesCount)
    },

    get activeImage() {
        return this.images[this.activeIndex] || null
    },

    get hasMoreImages() {
        return this.images.length > this.visibleImagesCount
    },

    get hasPrevious() {
        return this.activeIndex > 0
    },

    get hasNext() {
        return this.activeIndex < this.images.length - 1
    },

    init() {
        const modal = this.$refs.modal
        const boundOnKeyUp = this.boundOnKeyUp.bind(this)
        const focusTrap = createFocusTrap(modal)

        this.$watch('activeImage', (activeImage) => {
            if (activeImage) {
                window.addEventListener('keyup', boundOnKeyUp)
                this.$nextTick(() => {
                    disableBodyScroll(modal, {
                        reserveScrollBarGap: true,
                    })
                    focusTrap.activate()
                })
            } else {
                window.removeEventListener('keyup', boundOnKeyUp)
                enableBodyScroll(modal)
                focusTrap.deactivate()
            }
        })
    },

    boundOnKeyUp(event) {
        if (event.key === 'ArrowLeft') {
            this.previous()
        }

        if (event.key === 'ArrowRight') {
            this.next()
        }

        if (event.key === 'Escape') {
            this.close()
        }
    },

    show(index) {
        this.activeIndex = index
    },

    previous() {
        this.activeIndex = Math.max(0, this.activeIndex - 1)
    },

    next() {
        const next = Math.min(this.activeIndex + 1, this.images.length - 1)

        this.visibleImagesCount = Math.max(this.visibleImagesCount, next + 1)
        this.activeIndex = next
    },

    close() {
        this.activeIndex = null
    },

    loadMore() {
        const countToAdd = 12

        this.visibleImagesCount = Math.min(
            this.images.length,
            this.visibleImagesCount + countToAdd
        )
    },

    generateSrcSet(sizes, size) {
        const sources = Object.entries(sizes || {}).reduce(
            (acc, [name, url]) => {
                const isValidSize = [size, `${size}@2x`, `${size}@3x`].includes(
                    name
                )
                const urlAlreadyExists = Object.values(acc).includes(url)

                if (isValidSize && !urlAlreadyExists) {
                    acc[name] = url
                }

                return acc
            },
            {}
        )

        return Object.entries(sources)
            .map(([name, url]) => {
                const modifier =
                    name.length > size.length ? name.slice(size.length) : ''
                let descriptor = ''

                if (modifier.startsWith('@')) {
                    descriptor = modifier.slice(1)
                }

                return [url, descriptor].filter(Boolean).join(' ')
            })
            .filter(Boolean)
            .join(', ')
    },
})
